import { useGetSecureInstallComplianceQuery } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsSecureInstallComplianceRpc.hooks';
export function useGetSecureInstallCompliance({
  listingId,
  skip = false
}) {
  const {
    data,
    loading,
    error
  } = useGetSecureInstallComplianceQuery({
    variables: {
      listingId: listingId
    },
    skip: skip || !listingId
  });
  return {
    data,
    loading,
    error
  };
}